module.exports = __webpack_public_path__ + "static/graph3-cf5ff948cc7036702051c1747da01d8d.png";